import React from "react";

import { Box } from "@material-ui/core";

import SelectedStoreMarker from "components/visuals/maps/SelectedStoreMarker";

import Legend from "./Legend";

import { useAppSelector } from "store";
import { selectMapboxConfiguration } from "modules/siteConfiguration/siteConfigurationSlice";
import { selectRetailZoneCells, selectStore } from "modules/customer/insights/portfolioNew/portfolioSlice";
import HexLevel10Map, { MapCell } from "components/visuals/maps/HexLevel10Map";

const RETAIL_ZONE_CELLS_COLOURS = ['#FFFFFF'];

const Map: React.FC = () => {
    const mapboxConfiguration = useAppSelector(selectMapboxConfiguration);
    const { data: cells, isLoading, hasErrors } = useAppSelector(selectRetailZoneCells);
    const selectedStore = useAppSelector(selectStore);

    const [initialViewport, setInitialViewport] = React.useState({
        latitude: selectedStore?.latitude ?? 0,
        longitude: selectedStore?.longitude ?? 0,
        zoom: 13.5,
        minZoom: 4
    });

    React.useEffect(() => {
        setInitialViewport(current => {
            return {
                ...current,
                latitude: selectedStore?.latitude ?? 0,
                longitude: selectedStore?.longitude ?? 0
            };
        });
    }, [selectedStore]);

    const mapCells: MapCell[] = React.useMemo(() => {
        return cells.map(cell => ({
            id: cell.cellId,
            colourGroup: 0
        }));
    }, [cells]);

    return (
        <Box data-cy="retail-zone-map">
            <HexLevel10Map
                loading={isLoading}
                error={hasErrors}
                mapboxAccessToken={mapboxConfiguration.accessToken}
                mapboxBaseMapStyle={mapboxConfiguration.baseMapStyle}
                mapboxHexLevel10TilesetId={mapboxConfiguration.hex10TilesetId}
                mapboxHexLevel10TilesetUrl={mapboxConfiguration.hex10TilesetUrl}
                initialViewport={initialViewport}
                addGeocoder={false}
                cells={mapCells}
                colours={RETAIL_ZONE_CELLS_COLOURS}
            >
                <SelectedStoreMarker latitude={selectedStore?.latitude ?? 0} longitude={selectedStore?.longitude ?? 0} />
                <Legend store={selectedStore} retailZoneColour={RETAIL_ZONE_CELLS_COLOURS[0]} />
            </HexLevel10Map>
        </Box>
    );
};

export default Map;
